var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg20 = function Svg20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.833 6.483a.65.65 0 0 1 0-1.3h8.334a.65.65 0 0 1 .65.65v8.334a.65.65 0 1 1-1.3 0V7.403l-7.224 7.223a.65.65 0 0 1-.92-.919l7.224-7.224H5.833Z",
    fill: "currentColor"
  })));
};

export { Svg20 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjgzMzMzIDYuNDgzMzNDNS40NzQzNSA2LjQ4MzMzIDUuMTgzMzMgNi4xOTIzMiA1LjE4MzMzIDUuODMzMzNDNS4xODMzMyA1LjQ3NDM1IDUuNDc0MzUgNS4xODMzMyA1LjgzMzMzIDUuMTgzMzNIMTQuMTY2N0MxNC41MjU3IDUuMTgzMzMgMTQuODE2NyA1LjQ3NDM1IDE0LjgxNjcgNS44MzMzM1YxNC4xNjY3QzE0LjgxNjcgMTQuNTI1NyAxNC41MjU3IDE0LjgxNjcgMTQuMTY2NyAxNC44MTY3QzEzLjgwNzcgMTQuODE2NyAxMy41MTY3IDE0LjUyNTcgMTMuNTE2NyAxNC4xNjY3VjcuNDAyNTdMNi4yOTI5NSAxNC42MjYzQzYuMDM5MTEgMTQuODgwMSA1LjYyNzU2IDE0Ljg4MDEgNS4zNzM3MSAxNC42MjYzQzUuMTE5ODcgMTQuMzcyNCA1LjExOTg3IDEzLjk2MDkgNS4zNzM3MSAxMy43MDdMMTIuNTk3NCA2LjQ4MzMzSDUuODMzMzNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";